import { BaseComponent, BElement } from "utils/base-component"
import type { ExperimentAnalyticsParams } from "utils/experiment-analytics"
import {
  experimentParamsFromElement,
  trackExperimentExposure,
  trackExperimentInteraction,
} from "utils/experiment-analytics"
import "./index.scss"

require.context("./static", false, /\.(svg|webp)$/)

const APP_PROMO_MODAL_EXPERIMENT_ID = "app_promo_modal"

export class ModalAppPopup extends BaseComponent {
  static cssClass = "modal-app-popup"

  private close!: BElement
  private open!: BElement
  private closedClass!: string
  private actionTracked = false
  private experiment!: ExperimentAnalyticsParams

  init() {
    const closeElement = this.element("close-button")
    if (!closeElement) {
      throw new Error("Close button not found")
    }
    const openElement = this.element("open-button")
    if (!openElement) {
      throw new Error("Open button not found")
    }

    this.close = closeElement
    this.open = openElement

    this.closedClass = `${ModalAppPopup.cssClass}--closed`
    this.experiment = experimentParamsFromElement(this.root, {
      experimentId: APP_PROMO_MODAL_EXPERIMENT_ID,
      experimentVariant: "unknown",
    })

    if (document.cookie.indexOf("appPopupClosed=1") !== -1) {
      this.root.classList.add(this.closedClass)
      document.documentElement.style.paddingTop = "0"
    } else {
      this.trackShown()
    }

    const closePopup = (action?: string) => {
      this.trackAction(action)

      const expiryDate = new Date()
      expiryDate.setMonth(expiryDate.getMonth() + 1)

      document.cookie = `appPopupClosed=1; expires=${expiryDate.toUTCString()}; path=/`
      this.root.classList.add(this.closedClass)
    }

    this.root.addEventListener("click", (e) => {
      if (e.target === this.root) {
        closePopup("dismiss_backdrop")
      }
    })

    this.close.element.addEventListener("click", (e) => {
      e.preventDefault()
      closePopup(this.close.element.dataset.experimentAction)
    })

    this.open.element.addEventListener("click", () => {
      closePopup(this.open.element.dataset.experimentAction)
    })
  }

  private trackAction(action?: string) {
    if (!action || this.actionTracked) {
      return
    }

    this.actionTracked = true
    this.trackInteraction(action)
  }

  private trackShown() {
    trackExperimentExposure({
      ...this.experiment,
    })
  }

  private trackInteraction(experimentAction: string) {
    trackExperimentInteraction({
      ...this.experiment,
      experimentAction,
    })
  }
}
